import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthenticatedAxios } from '../useAuthenticatedAxios';
import { toast } from '../../../components/Toast';
import { controlKeys } from './controls.key';

type PatchCompanyPayload = {
  companyId: string;
  name?: string;
  registrationNumber?: string;
};

type Options = {
  onPatchCompanySuccess?: () => void;
  onPatchCompanyError?: (error: unknown) => void;
};

export function usePatchCompany(inspectionId: string, options?: Options) {
  const getAxios = useAuthenticatedAxios();
  const queryClient = useQueryClient();

  const patchCompany = async ({ companyId, ...data }: PatchCompanyPayload) => {
    const axios = await getAxios();
    const res = await axios.patch(`/api/v1/companies/${companyId}`, data);
    return res.data;
  };

  return useMutation(patchCompany, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: controlKeys.findCompanies(inspectionId),
      });
      options?.onPatchCompanySuccess?.();
    },
    onError: (error: unknown) => {
      toast.error('Kunde inte uppdatera bolaget');
      options?.onPatchCompanyError?.(error);
    },
  });
}
